import {Box, Typography} from '@mui/material';
import AurButton from '../aur-button/AurButton';
import {ReactComponent as LeftChev} from '../../../assests/svg/chev_left.svg';
import {ReactComponent as LeftChevDisable} from '../../../assests/svg/chev_left_disable.svg';
import {ReactComponent as RightChev} from '../../../assests/svg/chev_right.svg';
import {ReactComponent as RightChevDisable} from '../../../assests/svg/chev_right_disable.svg';
import styles from './style.module.scss';
import {t} from 'i18next';

type AurDrawerNavigationProps = {
  currentItemOrder: number;
  totalItemCount: number;
  previousIcon?: React.ReactNode;
  previousDisableIcon?: React.ReactNode;
  nextIcon?: React.ReactNode;
  nextDisableIcon?: React.ReactNode;
  previousButtonAriaLabel?: string;
  nextButtonAriaLabel?: string;
  navButtonClass?: string;
  aurDrawerNavigationClass?: string;
  navTypoClass?: string;
  navigationClickHandler: (itemOrder: number, isPrevious?: boolean) => void;
};

function AurDrawerNavigation({
  currentItemOrder,
  totalItemCount,
  previousIcon: PreviousIcon,
  previousDisableIcon: PreviousDisableIcon,
  nextIcon: NextIcon,
  nextDisableIcon: NextDisableIcon,
  previousButtonAriaLabel = '',
  nextButtonAriaLabel = '',
  aurDrawerNavigationClass = '',
  navButtonClass = '',
  navTypoClass = '',
  navigationClickHandler,
}: AurDrawerNavigationProps) {
  const isPreviousDisabled = !currentItemOrder || currentItemOrder == 1;
  const isNextDisabled = !totalItemCount || currentItemOrder == totalItemCount;
  let previousIcon: React.ReactNode = <LeftChev />;
  let nextIcon: React.ReactNode = <RightChev />;
  if (isPreviousDisabled) {
    previousIcon = PreviousDisableIcon ? (
      PreviousDisableIcon
    ) : (
      <LeftChevDisable />
    );
  } else {
    previousIcon = PreviousIcon ? PreviousIcon : <LeftChev />;
  }
  if (isNextDisabled) {
    nextIcon = NextDisableIcon ? NextDisableIcon : <RightChevDisable />;
  } else {
    nextIcon = NextIcon ? NextIcon : <RightChev />;
  }
  return (
    <Box
      className={`${styles.aurDrawerNavigation} ${aurDrawerNavigationClass}`}
    >
      <Box>
        <AurButton
          ariaLabel={previousButtonAriaLabel}
          disabled={isPreviousDisabled}
          startIcon={previousIcon}
          type="exit"
          size="Medium"
          onClick={() => navigationClickHandler(currentItemOrder - 1, true)}
          classNames={`${styles.aurDrawerNavigationDisableButton} ${navButtonClass}`}
        />
      </Box>
      <Box className={`${styles.valueContainer}`} component="nav">
        <Typography className={`${styles.selectedNumberText} ${navTypoClass}`}>
          {currentItemOrder}
        </Typography>
        <Typography className={`${styles.additionalText} ${navTypoClass}`}>
          {t('common.of')} {totalItemCount}
        </Typography>
      </Box>
      <Box>
        <AurButton
          ariaLabel={nextButtonAriaLabel}
          disabled={!totalItemCount || currentItemOrder == totalItemCount}
          startIcon={nextIcon}
          type="exit"
          size="Medium"
          onClick={() => navigationClickHandler(currentItemOrder + 1, false)}
          classNames={`${styles.aurDrawerNavigationDisableButton} ${navButtonClass}`}
          data-testid="nav-right"
        />
      </Box>
    </Box>
  );
}

export default AurDrawerNavigation;
